import { usePageLayout } from "./hooks/usePageLayout";

const DynamicHeader = () => {
  const { layout, loading } = usePageLayout();
  if (loading) return null;

  const inlinedHeader = layout.header
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
    .replace(/<link[^>]*>/gi, "")
    .replace(/\{\{home-page-url\}\}/g, "/")
    .replace(/\{\{login-page-url\}\}/g, "/login")
    .replace(/\{\{signup-page-url\}\}/g, "/signup")
    .replace(/classname=/gi, "class=");

  return <div dangerouslySetInnerHTML={{ __html: inlinedHeader }} />;
};

export default DynamicHeader;